export default "__VITE_ASSET__C6sItQZb__"